import { useTags } from "@/lib/hooks/tags/useTags";
import { unslugTagId } from "@/lib/utils/tagLabel";
import type React from "react";

interface SlideTagChipsProps {
  tagIds: readonly string[] | null | undefined;
}

export const SlideTagChips: React.FC<SlideTagChipsProps> = ({ tagIds }) => {
  const { tags } = useTags();
  if (!tagIds?.length) return null;

  const resolved = tagIds.map(
    (id) => tags.find((t) => t.id === id) ?? { id, name: unslugTagId(id), color: "#9ca3af" }
  );

  // Chips follow stored order — anything that needs a single tag takes the first, so the position
  // is numbered once there is more than one to choose between.
  const showOrder = resolved.length > 1;

  return (
    <div className="flex flex-wrap items-center gap-1">
      {resolved.map((tag, index) => (
        // Fixed width keeps chips aligned across cards; the full name lives in the hover tooltip.
        <span key={tag.id} className="relative group/tag">
          <span
            className="block w-24 px-2 py-0.5 rounded-full border label text-center truncate text-white"
            style={{ backgroundColor: tag.color, borderColor: tag.color }}
          >
            {showOrder ? `${index + 1}. ${tag.name}` : tag.name}
          </span>
          <span className="absolute bottom-full left-0 mb-1.5 z-50 pointer-events-none opacity-0 group-hover/tag:opacity-100 transition-opacity duration-150">
            <span className="block max-w-[12rem] bg-gray-900 text-white text-xs rounded-md px-2.5 py-1.5 shadow-lg break-words">
              {showOrder ? `${index + 1}. ${tag.name}` : tag.name}
            </span>
          </span>
        </span>
      ))}
    </div>
  );
};
